export default __webpack_public_path__ + "a75a76b25dc31fbe0ecb30a5b4479393.svg";